<template>
  <v-app app>
    <app-bar :hasNav="true" @onToggleNav="onToggleNav" />

    <app-notification />

    <v-slide-x-transition>
      <navigation-wrapper
        @onToggleNav="onToggleNav"
        :visible="navVisible"
        :list="list"
      />
    </v-slide-x-transition>

    <v-slide-x-transition hide-on-leave>
      <router-view />
    </v-slide-x-transition>

    <snack-bar />

    <app-error />
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      navVisible: false,
      list: []
    }
  },

  async mounted() {
    this.list = await this.apiGetSystemMenus()
  },

  methods: {
    async apiGetSystemMenus() {
      try {
        const res = await this.$store.dispatch(
          'leave/getStaffSystemMenus',
          this.$guid_target
        )
        return res
      } catch (e) {
        this.list = []
      }
    },

    onToggleNav(e) {
      if (e) {
        this.navVisible = e
      } else {
        this.navVisible = !this.navVisible
      }
    }
  }
}
</script>
